import type { KeyboardEvent as ReactKeyboardEvent } from 'react';
import type { PickingLecturaResult, PickingListoResult } from '../../services/pickingVentaService';
import { formatNroDocumentoVenta } from '../../utils/formatters';

/** Enter y Espacio los manda el lector al final del código; no deben accionar botones. */
export function detenerTeclaLector(event: ReactKeyboardEvent): void {
  if (event.key !== 'Enter' && event.key !== ' ' && event.code !== 'Space' && event.code !== 'NumpadEnter') {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
}

export function formatCantidadPicking(value?: number | null): string {
  const n = Number(value ?? 0);
  return (Number.isFinite(n) ? n : 0).toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
}

export function formatComprobantePicking(doc: {
  nroFormulario: number;
  letra?: string | null;
  nroSuc?: number | null;
  nroComprobante?: number | null;
}): string {
  return formatNroDocumentoVenta(doc.letra, doc.nroSuc, doc.nroComprobante) || `#${doc.nroFormulario}`;
}

/** La API clava el lector hasta aceptación manual (Swagger: bloquearLector / requiereAceptacionManual). */
export function lecturaRequiereAceptacion(r: PickingLecturaResult): boolean {
  if (r.bloquearLector === true || r.requiereAceptacionManual === true) return true;
  if (r.lecturaAplicada === false) return true;
  return false;
}

export function mensajeAlertaLectura(r: PickingLecturaResult, codigoLeido: string): string {
  const apiMsg = (r.message ?? r.mensaje ?? '').trim();
  if (apiMsg) return `${codigoLeido}: ${apiMsg}`;

  if (r.cantidadPedida > 0 && r.cantidadPickeada >= r.cantidadPedida && r.cantidadAplicada <= 0) {
    return `${codigoLeido}: La cantidad supera lo pedido (${formatCantidadPicking(r.cantidadPickeada)} / ${formatCantidadPicking(r.cantidadPedida)})`;
  }

  return `${codigoLeido}: Lectura no aplicada. Revisá el artículo o la cantidad.`;
}

/** listo sin cerrar: hay que decidir Cancelar / En espera. */
export function listoRequiereDecisionPendiente(r: PickingListoResult): boolean {
  if (r.cerrado === false) return true;
  if (r.bloquearLector === true || r.requiereAceptacionManual === true) return true;
  return false;
}

export function mensajeListoPendiente(r: PickingListoResult): string | null {
  const msg = (r.message ?? r.mensaje ?? '').trim();
  return msg || null;
}
